import React from "react";
import { Link } from "react-router-dom";
import Image from "../../../elements/Image";
import { projectList } from "../../../../services/projectService";
import useFetch from "../../../../hooks/useFetch";
import dayjs from "dayjs";
import { removeTag } from "../../../../helpers";

const ProjectItem = ({ data }) => {
  return (
    <Link
      to={"/projects"}
      state={{ projectData: data }}
      className="relative min-w-72 lg:min-w-0 flex flex-col py-4 px-4 bg-white shadow-[0_4px_20px_rgba(0,0,0,0.1)] hover:shadow-[0_8px_20px_rgba(0,0,0,0.2)] rounded-xl xls:rounded-2xl space-y-3 transition-all duration-200"
    >
      <div className="w-full overflow-hidden aspect-[7/5]">
        <Image src={data?.image} alt={data?.title} effect={"blur"} classes={"object-cover"} />
      </div>
      <div className="space-y-4 pb-4">
        <div className="flex items-center gap-10">
          {data?.date && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-calendars text-base xls:text-lg xl:text-xl"></i> {data?.date}
            </div>
          )}
          {data?.time && (
            <div className="text-xs xls:text-sm xl:text-base font-CanelaDeck font-medium inline-flex items-center gap-1">
              <i className="fa-light fa-fw fa-clock text-base xls:text-lg xl:text-xl text-chestnut-rose"></i> {data?.time}
            </div>
          )}
        </div>
        <h2 className="text-sm xls:text-base xl:text-xl font-semibold">
          {data?.title?.length > 50 ? data.title.substring(0, 60) + "..." : data?.title} <span className="font-Gotham text-chestnut-rose font-medium inline-flex ml-2">Read More</span>
        </h2>
      </div>
    </Link>
  );
};

const ProjectSection = () => {
  const {
    data: projectData,
    error,
    isLoading,
    updateData,
    isFetching,
    refetch,
  } = useFetch({
    dependencies: ["font-projects"],
    fetchFunction: async () => {
      const res = await projectList({
        limit: 3,
      });
      if (res?.docs?.status === 200) {
        return res?.docs?.data?.map((item) => ({
          image: item?.image?.url,
          ...(item?.startDate && {
            date: dayjs(item?.startDate).format("MMMM DD, YYYY"),
          }),
          title: removeTag(item?.description),
          id: item?._id,
        }));
      } else {
        return [];
      }
    },
  });

  return (
    <>
      <section className="relative flex w-full py-16 sm:py-24">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="space-y-10 sm:space-y-16 -mx-4 md:-mx-[calc(((100vw-42rem)/2)+1rem)] lg:mx-0">
            <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">Project</h2>
              <div className="md:flex-col lg:grid grid-cols-3 gap-4 lg:gap-3 xls:gap-6 overflow-auto lg:overflow-visible pt-2 pb-6 lg:py-0 px-4 md:px-[calc(((100vw-42rem)/2)+1rem)] lg:px-0 space-y-10 lg:space-y-0">
                {projectData?.map((item, index) => (
                  <ProjectItem key={index} data={item} />
                ))}
              </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjectSection;
